/* import __COLOCATED_TEMPLATE__ from './preview-module.hbs'; */
/* RESPONSIBLE TEAM: team-actions */
import type Owner from '@ember/owner';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type FinVoiceService from 'embercom/services/fin-voice-service';

interface Signature {
  Args: {
    canSwapConfigs: boolean;
  };
  Blocks: {
    default: [];
    additionalActions: [];
  };
  Element: HTMLElement;
}

export default class PreviewModule extends Component<Signature> {
  @service declare finVoiceService: FinVoiceService;

  get hasSessions() {
    return this.finVoiceService.sessions.length > 0;
  }

  get verboseLogsEnabled() {
    return this.finVoiceService.verboseLogsEnabled;
  }

  constructor(owner: Owner, args: Signature['Args']) {
    super(owner, args);

    this.finVoiceService.clearAllSessions();
  }

  @action
  copyLatestSessionId() {
    return this.finVoiceService.copyLatestSessionId();
  }

  @action
  copyTranscript() {
    return this.finVoiceService.copyTranscript();
  }

  @action
  toggleVerboseLogsEnabled() {
    this.finVoiceService.verboseLogsEnabled = !this.finVoiceService.verboseLogsEnabled;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Voice::Preview::PreviewModule': typeof PreviewModule;
    'ai-agent/voice/preview/preview-module': typeof PreviewModule;
  }
}
